import React from 'react'

interface CheckBoxDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CheckBoxDT: React.FC<CheckBoxDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M7.50033 18.3346H12.5003C16.667 18.3346 18.3337 16.668 18.3337 12.5013V7.5013C18.3337 3.33464 16.667 1.66797 12.5003 1.66797H7.50033C3.33366 1.66797 1.66699 3.33464 1.66699 7.5013V12.5013C1.66699 16.668 3.33366 18.3346 7.50033 18.3346Z" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.05859 8.86719L10.0003 11.8005L12.9419 8.86719" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default CheckBoxDT
